<template>
  <div
    v-if="visible"
    class="gw_pulse-circle"
    @click="handleClick"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PulseCircle',
  props: {
    oneTimeOnly: Boolean,
    isVisible: {
      type: Boolean,
      default: false,
    },
    localKey: String,
  },
  emits: ['click'],
  data() {
    return {
      visible: false,
      // visible: true,
    }
  },
  created() {
    if (this.oneTimeOnly) {
      this.visible = localStorage.getItem(this.localKey) !== 'closed'
    }
    if (this.isVisible) {
      this.visible = true
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
      this.close()
    },
    close() {
      if (this.localKey) {
        localStorage.setItem(this.localKey, 'closed')
      }
      this.visible = false
    },
  },
  watch: {
    isVisible(val) {
      this.visible = val
    },
  },
}
</script>

<style lang="scss">
.gw_pulse-circle {
  --size: 0.5rem;
  --height: var(--size);
  --width: var(--size);
  --size-ring: 666%;
  --size-ring-hover: 333%;
  --scale-hover: 1.125;
  // --rgb: 0, 0, 0;
  --rgb: 0, 172, 141; // primary
  // --rgb: 35, 181, 239; // blue

  --scale-from: 0.1;
  --scale-to: 0.8;
  --anim-time: 4s;

  position: absolute;
  z-index: 99;

  height: var(--height);
  width: var(--width);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--clr-primary);
  box-shadow:
    0 0 1px var(--clr-primary),
    0 0 2px var(--clr-primary),
    0 0 3px var(--clr-primary);
  transition: transform 0.2s ease-out;
  &:hover {
    cursor: pointer;
    transform: scale(var(--scale-hover));
    --size-ring: var(--size-ring-hover);
  }
  &:before {
    content: '';
    transition: 0.3s;
    animation: ripple var(--anim-time) infinite;
    animation-timing-function: ease-out;
    height: var(--size-ring);
    width: var(--size-ring);
    position: absolute;
    display: block;
    box-sizing: border-box;
    border-radius: inherit;
    box-shadow: 0 0 3px 3px var(--clr-primary);
    pointer-events: none;
  }
  &:after {
    content: '';
    transition: 0.3s;
    animation: ripple-delayed var(--anim-time) infinite;
    animation-timing-function: ease-out;
    height: var(--size-ring);
    width: var(--size-ring);
    position: absolute;
    display: block;
    box-sizing: border-box;
    border-radius: inherit;
    box-shadow: 0 0 3px 3px var(--clr-primary);
    pointer-events: none;
  }
}

@keyframes ripple {
  0% {
    transform: scale(var(--scale-from));
    opacity: 0;
  }
  2.5% {
    opacity: 0.6;
  }
  50% {
    transform: scale(var(--scale-to));
    opacity: 0;
  }
  100% {
    transform: scale(var(--scale-to));
    opacity: 0;
  }
}

@keyframes ripple-delayed {
  0% {
    transform: scale(var(--scale-from));
    opacity: 0;
  }
  6% {
    opacity: 0.6;
    transform: scale(var(--scale-from));
  }
  100% {
    transform: scale(var(--scale-to));
    opacity: 0;
  }
}
</style>
